module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAYAAABX5MJvAAABZklEQVRYhb3WPU7DMACG4TelLAxVuEArZpDoDIIJLsARcgvEDJcA9UIEiRsgOEEXprZ8DDjCqpzEP3E+KYrsWPYjx7FTSAKYAwfAB+PlBNgBX0i6lLSRtJVUSWKEqzLjbSRdTIFzYGp0L+a+yjgDFfAMTEx5iaSZpFr/+ck4I5WknTVWLWnWPCxHgLgAx5KwG+WEtAL2EbkgnQAXYmhIL6ANMRTEBShdbbs6SYF4A/oQsZAggA8iFBIM8EX4QqIAIYg+SDQgFNEGWaUAYhAuiJ1ggCQKSTEnYQm8Awur7hNYAuvQzib9TZy54+9HyM7c1Icn4nVUZi00+d5bI8FbfCqglrRQ4hafCmgWYdJZMwSg6/P1ggwFSIIMCYiGDA2IguQABENyAYIgOQHekNwAG/LaBhkD0AtB0tUIgC7I9QQ4Awpznr0BN0Qcx55ZA7dAbcoFcFpIOgKegEPgISPATgk8Alvg/he2q2AEfUFzvgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/icon-del.png
// module id = zzsZ
// module chunks = 1